import { render, staticRenderFns } from "./AppVersionControl.vue?vue&type=template&id=4ab914ef&"
import script from "./AppVersionControl.vue?vue&type=script&lang=js&"
export * from "./AppVersionControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports